import { render, staticRenderFns } from "./stages.vue?vue&type=template&id=fa61c030&scoped=true"
import script from "./stages.vue?vue&type=script&lang=js"
export * from "./stages.vue?vue&type=script&lang=js"
import style0 from "./stages.vue?vue&type=style&index=0&id=fa61c030&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa61c030",
  null
  
)

export default component.exports